import React from 'react'
import './Blog.css'

import { useState, useEffect } from 'react'

export default function About() {


    const [blogs, setBlogs] = useState([

    ])


    useEffect(() => {

        fetch("blogs.json")
            .then(response => response.json())
            .then(data => setBlogs(data))

    }, [])


    return (
        <div className='blog-container'>
            <div className="content">
                <h3>Blog</h3>
                <div className='golden-bar'></div>
                <div className="blog-container-bottom">
                    <div className="blog-cards">
                        {
                            blogs.map(blog => (
                                <div key={blog.id || blog.title} className="blog-card">
                                    <img src={blog.image} alt="" />
                                    <div className="blog-info">
                                        <p>{blog.date}</p>
                                        <h2>{blog.title}</h2>
                                        <p className='desc'>{blog.desc}</p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
